
import App from '@/App.vue'
import { createApp } from 'vue'
import { store } from '@/store' 
import { router } from '@/router'
import WaveUI from 'wave-ui/src/wave-ui/core'
import '@mdi/font/css/materialdesignicons.min.css'

import { WApp, WButton, WFlex, WAlert, WDrawer, WOverlay, WToolbar, WIcon, WImage, WProgress, WDivider, WTable, WTag, WSpinner } from 'wave-ui/src/wave-ui/components'

const app = createApp(App)
app.use(WaveUI, {
  components: { WApp, WButton, WFlex, WAlert, WDrawer, WOverlay, WToolbar, WIcon, WImage, WProgress, WDivider, WTable, WTag, WSpinner}
})
new WaveUI(app, {})
app.use(router)
app.use(store)

app.mount('#app')

export { app }